

export const environment = {
  production: false,
  

 
   API_URL: "https://api.reignhealth.io/api/v1/", 
 









  


  
};
